import React from 'react';
import SvgIcon from '../SvgIcon/SvgIcon';
import { IconName } from '../../assets/icons';

interface SummaryCardProps {
  title: string;
  value: string | number;
  rate?: string;
  levelUp?: boolean;
  levelDown?: boolean;
  iconName?: IconName;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  rate = '',
  levelUp = false,
  levelDown = false,
  iconName = 'default',
}) => {
  return (
    <div className="rounded-sm border border-stroke bg-white px-6 py-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-meta-2 dark:bg-meta-4">
        <SvgIcon
          name={iconName}
          className="fill-primary dark:fill-white"
          width={24}
          height={24}
        />
      </div>

      <div className="mt-4 flex items-end justify-between">
        <div className="min-w-0">
          <h4
            className="text-2xl font-bold text-black dark:text-white whitespace-nowrap overflow-hidden text-ellipsis"
            title={String(value)}
          >
            {value}
          </h4>
          <span
            className="text-sm font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap overflow-hidden text-ellipsis block"
            title={title}
          >
            {title}
          </span>
        </div>

        <span
          className={`flex items-center gap-1 text-sm font-medium ${
            levelUp ? 'text-green-500' : ''
          } ${levelDown ? 'text-red-500' : ''}`}
        >
          {rate}
          {levelUp && (
            <SvgIcon
              name="arrow-up-trend"
              className="fill-green-500"
              width={10}
              height={11}
            />
          )}
          {levelDown && (
            <SvgIcon
              name="arrow-down-trend"
              className="fill-red-500"
              width={10}
              height={11}
            />
          )}
        </span>
      </div>
    </div>
  );
};

export default SummaryCard;
